import { db } from "@/db";
import { poll, User, user } from "@/db/schema";
import { getUserSession } from "@/lib/api/auth.api";
import { auth } from "@/lib/better-auth/auth";
import { updatePollSchema } from "@/lib/zod-schemas/update-poll.schema";
import { redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { and, eq } from "drizzle-orm";

export type UserDetails = User & {
  followersCount: number;
  followingCount: number;
  isFollowedByUser: boolean;
  pollsCount: number;
};

export const updatePoll = createServerFn({ method: "POST" })
  .inputValidator(updatePollSchema)
  .handler(async (ctx) => {
    const request = getRequest();
    const userSession = await auth.api.getSession({ headers: request.headers });
    if (!userSession?.user) {
      throw redirect({
        to: "/sign-in",
      });
    }

    const { id, deleted } = ctx.data;

    const updateData: Partial<typeof poll.$inferInsert> = {};
    if (deleted !== undefined) updateData.deleted = deleted;

    if (Object.keys(updateData).length === 0) {
      return { success: true, message: "Nothing to update" };
    }

    await db
      .update(poll)
      .set(updateData)
      .where(and(eq(poll.id, id), eq(poll.authorId, userSession.user.id)))
      .execute();

    return { success: true, message: "Poll updated successfully" };
  });
